import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { ApiService } from "src/app/services/api.service";
import { SessionService } from "src/app/services/session.service";

@Component({
  selector: "app-callback",
  templateUrl: "callback.component.html",
  styles: []
})
export class CallbackComponent implements OnInit {
  statusMessage: string = "Procesando autenticación...";
  isError: boolean = false;
  showCloseSessionsButton: boolean = false;
  isLoading: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private sessionService: SessionService
  ) {}

  private userRun: string | null = null;

  ngOnInit(): void {
    if (this.sessionService.isAuthenticated()) {
      if (this.sessionService.sesionEnConflicto) {
        this.router.navigate(["/conflicto-sesion"]);
      } else {
        this.router.navigate(["/inicio"]);
      }
      return;
    }

    const rawError = this.route.snapshot.queryParamMap.get("error");
    const uuid = this.route.snapshot.queryParamMap.get("uuid");

    console.log("Raw error param:", rawError);
    console.log("All query params:", this.route.snapshot.queryParamMap.keys);

    // El error puede venir como "mensaje|run" desde la lambda token-cu
    let error = rawError;
    if (rawError?.includes("|")) {
      const parts = rawError.split("|");
      error = parts[0];
      this.userRun = parts[1] || null;
    } else {
      this.userRun = this.route.snapshot.queryParamMap.get("run")
        || this.extractRunFromError(rawError);
    }

    if (error) {
      if (error.includes("ya tiene una sesión activa")) {
        this.statusMessage = error;
        this.showCloseSessionsButton = true;
        this.isError = true;
        this.isLoading = false;
        return;
      }
      
      const logout = this.route.snapshot.queryParamMap.get("logout");
      if (!logout) {
        const logoutRedirect = new URL(window.location.href);
        logoutRedirect.searchParams.set("logout", "true");
        const claveUnicaLogoutUrl = `https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout?redirect=${encodeURIComponent(
          logoutRedirect.toString()
        )}`;
				window.location.href = claveUnicaLogoutUrl;
      }

      this.statusMessage = error.toString();
      this.isError = true;
      this.isLoading = false;

      return;
    }

    if (!uuid) {
      console.error("UUID no encontrado en los parámetros");
      this.statusMessage = "ERROR: UUID NO ENCONTRADO";
      this.isError = true;
      return;
    }

    const backendUrl = environment.apiFisca + environment.fiscaRecSesion;

    this.apiService.privatePostObservable<any>(backendUrl, { uuid }).subscribe({
      next: async (response) => {
        if (typeof response === "object") {
          try {
            const sesion = response.Sesion?.[0];
            if (!sesion) {
              console.error("La respuesta no contiene datos de sesión válidos");
              this.statusMessage = "ERROR: SESIÓN NO VÁLIDA";
              this.isError = true;
              this.isLoading = false;
              return;
            }
            sesion.permisos = JSON.parse(sesion.permisos).data; // Transformar permisos serializados a objeto
            await this.sessionService.setSesion(sesion);

            // El backend indica si la sesión ya existía activa (recuperada).
            console.log(sesion);
            if (sesion.es_sesion_recuperada) {
              this.sessionService.sesionEnConflicto = true;
              this.isLoading = false;
              this.router.navigate(["/conflicto-sesion"]);
              return;
            }

            this.statusMessage = "Autenticación completada";
            this.isError = false;

            setTimeout(() => {
              this.isLoading = false;
              this.router.navigate(["/inicio"]);
            }, 700);
          } catch (e) {
            this.isLoading = false;
            console.error("Error al parsear la respuesta del backend:", e);
            this.statusMessage = "ERROR AL PROCESAR RESPUESTA";
            this.isError = true;
          }
        } else {
          this.isLoading = false;
          console.error("La respuesta del backend no es un string válido");
          this.statusMessage = "RESPUESTA INVÁLIDA DEL BACKEND";
          this.isError = true;
        }
      },
      error: (err) => {
        console.error("Error al obtener sesión:", err);
        this.statusMessage = "ERROR AL OBTENER SESIÓN";
        this.isError = true;
      },
    });
  }

  /**
   * Intenta extraer el RUN (sin DV) del mensaje de error.
   * Busca patrones como "12345678-9" o "12345678-K" y retorna solo la parte numérica.
   */
  private extractRunFromError(error: string | null): string | null {
    if (!error) return null;
    const match = error.match(/(\d{7,8})-[\dkK]/);
    return match ? match[1] : null;
  }
}
